import axios from "axios";
import { mail, forgot_password_mail, appointment_mail, purchased_package_mail, otp_mail } from "../apiConfig";
import { getToken } from "../../localstorage";

export const send_mail = async (data, action='mail') => {
  let _endpoint = mail;
  switch (action) {
    case 'mail':
      _endpoint = mail;
      break;
    case 'forgot_password':
      _endpoint = forgot_password_mail;
      break;
    case 'appointment':
      _endpoint = appointment_mail;
      break;
    case 'purchased_package':
      _endpoint = purchased_package_mail;
      break;
    case 'otp':
      _endpoint = otp_mail;
      break;
  }
  const formData = new URLSearchParams();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return axios.post(_endpoint, formData, {
    headers: {
      "X-API-KEY": "kpjhealth",
      "Authorization": `Bearer ${getToken()}`,
      "Content-Type": "application/x-www-form-urlencoded"
    },
  })
  .then((res) => {
    return res.data;
  }).catch((err) => {
    throw err;
  });
}